import type { Moment } from 'moment'

import { tracking } from '@driftt/traffic-control'

import useTimePeriod from 'hooks/useTimePeriod'

export const trackDrillDownClick = (
  drilldownName: string,
  startDate: Moment,
  endDate: Moment,
  totalCount?: number
) =>
  tracking.trackEvent('CUBE_DRILL_DOWN_CLICK', {
    metricType: drilldownName,
    startDate,
    endDate,
    totalCount,
    pageName: window.location.pathname,
  })

export const useTrackDrillDownClickEvent = (drilldownName) => {
  const timePeriod = useTimePeriod()

  const trackViewEvent = ({ totalRecords = 0 }: { totalRecords?: number }) => {
    trackDrillDownClick(
      drilldownName,
      timePeriod.startDate,
      timePeriod.endDate,
      totalRecords
    )
  }

  return {
    trackViewEvent,
  }
}
